import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {CommonModule} from "@angular/common";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { jwtDecode } from 'jwt-decode';
import { ThemeService } from '../../services/theme.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit{
  submitted = false;
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });
  errors: string[] = [];
  isLogged:boolean = false;

  isDev:boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private msalService: MsalService,
    private themeService: ThemeService,
  ) {
  }


  ngOnInit() {
    this.msalService.initialize().subscribe((response) => {
      this.isLoggedIn();
    });
    this.isDev = window.location.href.includes('localhost');

  }

  isLoggedIn() {
    this.isLogged = this.msalService.instance.getActiveAccount() != null;
  }

  // SSO LOGIN
  loginSso() {
    this.msalService.loginPopup()
      .subscribe({
        next: (result) => {
         const token = result.accessToken;
         if(token){
           this.authService.checkAzureTokenInBack(token).subscribe({
             next: (data) => {
              const tokenData = JSON.stringify({"token"  : data['message']});
              localStorage.setItem('jwt', tokenData);
              this.router.navigate(['']);
            },
              error: (error) => {
                console.log(error);
                this.errors.push("Erreur lors de la connexion : "+error.error.detail);
                setTimeout(() => {
                  this.errors = [];
                }, 5000);
              }
           });
         }else{
          this.errors.push('Token not found');
         }
        },
        error: (error) =>  {
          this.errors.push(error);
        }
      });
  }

  logout() {
    this.msalService.logout();
  }

  submitForm(): void {
    this.submitted = true;
    this.errors = []

    if (this.loginForm.valid) {
      this.authService.login(this.loginForm.get('email')!.value, this.loginForm.get('password')!.value).subscribe({
        next: (data) => {
          this.router.navigate([''])
        },
        error:
          (err) => {
            if (err.error.message) {
              this.errors.push(err.error.message)
            }
            else if(err.message)
            {
              this.errors.push(err.message)
            }
          }
      });
    }
  }
}
